import { LoaderCircle } from "lucide-react";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { Button as UiButton } from "./ui/button";
import { cn } from "./cn";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
export type ButtonSize = "sm" | "md" | "lg" | "icon";
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  loadingLabel?: string;
}
const variants = { primary: "default", secondary: "outline", ghost: "ghost", danger: "destructive" } as const;
const sizes = { sm: "sm", md: "default", lg: "lg", icon: "icon" } as const;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = "primary", size = "md", type = "button", isLoading = false, loadingLabel, disabled, children, ...props }, ref
) {
  return (
    <UiButton ref={ref} type={type} variant={variants[variant]} size={sizes[size]}
      className={cn("shadow-none focus-visible:ring-2 focus-visible:ring-ring/25", variant === "secondary" && "bg-card", className)}
      disabled={disabled || isLoading} aria-busy={isLoading || undefined} {...props}>
      {isLoading && <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />}
      {isLoading && loadingLabel ? loadingLabel : children}
    </UiButton>
  );
});
